import { Component, OnInit, Input, Output, EventEmitter, OnDestroy  } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';
import { Subscription } from 'rxjs';

import { ActivityService, Activity, ActivityId, PdfActivityDisplayLabels } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';
import { UnitService } from '../../services/unit.service';

import { QuotationFunctionData } from '../../quotation-activity-functions';
import { ProductCmpaService } from '../../services/product-cmpa.service';
@Component({
	selector: 'app-update-activity',
	templateUrl: './update-activity.component.html',
	styleUrls: ['./update-activity.component.css', '../../app.component.css']
})

export class UpdateActivityComponent implements OnInit, OnDestroy {

	activityForm: FormGroup;
	activity: any = [];

	classifications = {};
	classificationInit: any;
	classificationTxt: string;

	units: any[] = [];
	@Input() unitInit: string;
	@Output() unitModelChange = new EventEmitter();

	id: string;

	modalActions = new EventEmitter<string|MaterializeAction>();
	modalParams = [ {
		dismissible: false,
		complete: function() {
			// console.log('Modal : Close');
		}
	} ];

	classificationForm: FormGroup;
	classification: any;

	activitySub: Subscription;
	activityClassSub: Subscription;
	activityClassSub2: Subscription;
	mUnitSub: Subscription;
	prCmpaSub: Subscription;

	activityFunctionDatas: any;
	generalfunctionSelects: any[];
	sectionfunctionSelects: any[];

	unique: any = {
		papel: {prCmpaId: '', prCmpaDescription: ''}
	};
	activityIsGeneral: boolean;
	currentFunction: any;
	dataCalc: number;
	labels: string[];
	appliesPrVnta: boolean = false;
	appliesOdP: boolean = false;
	pdfDisplay: Activity['pdfDisplay'] = {key1: false, key2: false, key3: false};
	pdfLabels = PdfActivityDisplayLabels;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private activityService: ActivityService,
		private activityClassificationService: ActivityClassificationService,
		private unitService: UnitService,
		private prCmpaService: ProductCmpaService,
		private quotationFunctionData: QuotationFunctionData
	) {
		this.activityFunctionDatas = this.quotationFunctionData.functionData;
		this.generalfunctionSelects = [];
		this.sectionfunctionSelects = [];
		quotationFunctionData.selectArray.map(data => {
			if(data.isGeneral) this.generalfunctionSelects.push(data);
			else this.sectionfunctionSelects.push(data);
		})
		this.loadClassifications();
		this.loadUnits();


		this.prCmpaSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
			this.rowsRead[0] = prCmpas.map(({characs, prices, ...prCmpa}) => {
				prCmpa.prTypeName = prCmpa.data.name;
				prCmpa.characs = characs.reduce((acc, cur, index) => {
					let unit = this.units.find(({id}) => id == cur.unitId.id);
					let symbol = unit ? unit.symbol : '';
					return acc + `${index ? ', ' : ''}${cur.name}: ${cur.value}${symbol}`;
				}, '');
				prCmpa.higherPrice = Math.max(0, ...prices.map(({price}) => price));
				this.prCmpas[prCmpa.id] = {...prCmpa};
				return prCmpa;
			});
		});

		
		this.id = this.activatedRoute.snapshot.paramMap.get('id');
		this.activitySub = this.activityService.getActivity(this.id).subscribe(({minPrice=0, ...activity}: ActivityId) => {
			console.log(activity);
			const activityTmp = { classification: '', ...activity };
			this.activityIsGeneral = activity.isGeneral;
			this.currentFunction = this.activityFunctionDatas[activity.quantityPricesFunction];
			this.dataCalc = activity.dataCalc;
			this.activityClassSub = this.activityClassificationService.getActivityClassification(activity.activityClassificationRef.id).subscribe(activityClass => {
				activityTmp.classification = activityClass.name;
				this.activity = activityTmp;
				this.classificationTxt = this.activity.classification;
				if(this.activity.dataCalc > 0){
					this.labels = this.currentFunction.labels;
					this.activity.prices.map(number => {
						this.prices.push(this.formBuilder.group({price: number}));
					});
				}else{
					this.activity.ranges.map(range => {
						this.ranges.push(this.formBuilder.group({
							min: [range.min, Validators.required],
							max: [range.max, Validators.required],
							price: [range.price, Validators.required]
						}));
					});
					
				}
				this.activityForm.get('name').setValue(this.activity.name);
				this.activityForm.get('classification').setValue(this.classificationTxt);
				this.activityForm.get('minPrice').setValue(minPrice);
				this.unitInit = this.activity.measurementUnitRef ? this.activity.measurementUnitRef.id : this.unitInit;
				this.activityForm.get('quantityPricesFunction').setValue(this.activity.quantityPricesFunction);
				if(this.activity.quantityPricesFunction == 'papel') this.selectedIds[0] = this.activity.unique && this.activity.unique.prCmpaId || '';
				this.appliesPrVnta = activity.appliesPrVnta;
				activity.appliesOdP ? this.appliesOdP = activity.appliesOdP : false
				if(activity.pdfDisplay) this.pdfDisplay = activity.pdfDisplay;
				
			});
		});
	}

	ngOnInit() {
		this.activityForm = this.formBuilder.group({
			name: ['', Validators.required],
			classification: ['', Validators.required],
			quantityPricesFunction: ['',Validators.required],
			value: [''],
			unit: [''],
			minPrice: 0,
			ranges: this.formBuilder.array([]),
			prices: this.formBuilder.array([])
		});

		this.classificationForm = this.formBuilder.group({
			nameCla: ['', Validators.required],
			descriptionCla: ['', Validators.required],
			perSection: ''
		});
	}
	ngOnDestroy() {
		this.activitySub.unsubscribe();
		this.activityClassSub.unsubscribe();
		this.activityClassSub2.unsubscribe();
		this.mUnitSub.unsubscribe();
	}

	get qpFunction(){ return this.activityForm.get('quantityPricesFunction').value; }

	onSubmitActivity() {
		let activity: Activity = this.saveActivity();
		console.log(activity)

		this.activityService.updateActivity(this.id, activity);
		this.router.navigate(['/activities']);
	}

	saveActivity() {
		const activityJson = {
			activityClassificationRef: this.classifications[this.activityForm.get('classification').value].id,
			isGeneral: this.classifications[this.activityForm.get('classification').value].isGeneral,
			quantityPricesFunction: this.activityForm.get('quantityPricesFunction').value,
			measurementUnitRef: this.activityForm.get('unit').value,
			name: this.activityForm.get('name').value,
			updatedAt: new Date(),
			value: this.activityForm.get('value').value,
			dataCalc: this.dataCalc,
			ranges: this.ranges.value ? this.ranges.value : [],
			prices: this.prices.value ? this.prices.value.map(object => object.price) : [],
			appliesPrVnta: this.appliesPrVnta,
			appliesOdP: this.appliesOdP,
			unique: this.quotationFunctionData.functionData[this.qpFunction].hasUnique && this.unique[this.qpFunction] || {},
			minPrice: this.activityForm.value.minPrice,
			pdfDisplay: this.pdfDisplay
		};
		return activityJson as Activity;
	}

	loadClassifications() {
		this.activityClassSub2 = this.activityClassificationService.getActivityClassifications().subscribe(tempClassifications => {
			console.log(tempClassifications);
			const data = {};

			for (const idx in tempClassifications) {
			  data[tempClassifications[idx].name] = null;

			  this.classifications[tempClassifications[idx].name] = { id: tempClassifications[idx].id$, isGeneral: !tempClassifications[idx].perSection };
			  this.classifications[tempClassifications[idx].id$] = { name: tempClassifications[idx].name, isGeneral: !tempClassifications[idx].perSection };
			}

			this.classificationInit = {
				'data': data,
				onAutocomplete: (val) => {
				}
			};
		});
	}

	loadUnits() {
		this.mUnitSub = this.unitService.getUnits().subscribe(units => {
			this.units = units;
			if(!this.unitInit) this.unitInit = units[0].id;
		});
	}

	onBlurClassification() {
		if (this.classifications[this.activity.classification] === undefined) {
			this.activity.classification = '';
		}
	}
	onBlurUnit() {
		const index = this.units.map(unit => unit.id).indexOf(this.activityForm.get('unit').value);
      if (index === -1) {
        this.activityForm.get('unit').setValue('');
      }
	}
		
	get ranges(): FormArray {
		return this.activityForm.get('ranges') as FormArray;
	}

	get prices(): FormArray {
		return this.activityForm.get('prices') as FormArray;
	}
	
	rangeForm() {
		return this.formBuilder.group({
			min: [0, Validators.required],
			max: [0, Validators.required],
			price: [0, Validators.required]
		});
	}
	priceForm(){
		return this.formBuilder.group({
			price: ['', Validators.required]
		});
	}

  addNewRange() {
    this.ranges.push(this.rangeForm());
  }

  removeRange(index: number) {
    this.ranges.removeAt(index);
  }

	changeUnit(unitValue) {
		this.unitModelChange.emit(unitValue);
	}

	openModal() {
		this.modalActions.emit({ action: 'modal', params: ['open'] });
	}

	closeModal() {
		this.modalActions.emit({ action: 'modal', params: ['close'] });
	}

	onSubmitClassification() {
		this.classification = this.saveClassification();

		this.activityClassificationService.postActivityClassification(this.classification);
		this.classificationForm.reset();

		this.loadClassifications();

		this.closeModal();
		this.activityForm.get('classification').patchValue(this.classification.name);
	}

	saveClassification() {
		const currentDate = new Date();

		const classificationJson = {
			active: 1,
			createdAt: currentDate,
			description: this.classificationForm.get('descriptionCla').value,
			name: this.classificationForm.get('nameCla').value,
			perSection: !!this.classificationForm.get('perSection').value,
			updatedAt: currentDate
		};

		return classificationJson;
	}

	onChangeClassification(className){
		if(!this.validClassification) return;
		const c = this.classifications[className];
		if(c) this.activityIsGeneral = c.isGeneral;
		if(c.isGeneral) var array = this.generalfunctionSelects;
		else var array = this.sectionfunctionSelects;
		this.activityForm.get('quantityPricesFunction').patchValue(array[0].value);
		this.onChangeFunction(array[0].value);
	}
	onChangeFunction(functionValue){
		this.currentFunction = this.activityFunctionDatas[functionValue];
		this.dataCalc = this.currentFunction.dataCalc;
		while(this.prices.length > 0) this.prices.removeAt(0); //reset prices por pushing
		this.labels = this.currentFunction.labels;
		if (this.currentFunction.dataCalc === 0 && this.ranges.length === 0) this.ranges.push(this.rangeForm());
		else if(this.currentFunction.dataCalc > 0 ) for(var i = 0; i < this.currentFunction.dataCalc; i++) this.prices.push(this.priceForm());
	}

	get validClassification(){
		return !!this.classifications[this.activityForm.get('classification').value];
	}



	//////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA
	selectedIds: string[] = [];
	prCmpas = {};
	get selectedPrCmpaId(): string { return this.selectedIds[0]; }
	
	get readValid(){ return true };// this.selectedPrCmpaId || this.qpFunction != 'papel' };
	
	currentReadIndex: number;
	rowsRead = [[]];
	columnsRead = [
		[//prCmpa
			{title: 'Nombre', name: 'name',sort: 'asc'},
			{title: 'Características', name: 'characs'},
			{title: 'Clasificación' , name: 'prTypeName'},
			{title: 'Código', name: 'code'}
		]
	]

	modalActionsRead = new EventEmitter<string|MaterializeAction>();
	modalParamsRead = [{dismissible: true}];
	openModalRead(index: number) {
		this.currentReadIndex = index;
		this.data = this.rowsRead[index];
		
		this.config = this.configs[index];
	
		this.onChangeTable(this.config);
		this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
	}
	closeModalRead() {
		this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
	}
	selectRead(data: any): any{
		this.selectedIds[this.currentReadIndex] = data.row.id;
		if(this.qpFunction == 'papel'){
			this.unique.papel.prCmpaId = this.selectedPrCmpaId;
			this.unique.papel.prCmpaDescription = `${data.row.name} - ${data.row.characs}`;
			this.activityForm.get('prices').setValue([{price: this.prCmpas[this.selectedPrCmpaId].higherPrice}]);
		}
		this.closeModalRead();
	}
	unselectRead(index: number){
		this.closeModalRead();
		this.selectedIds[index] = '';
	}


	data:Array<any>;
	rows:Array<any> = [];
	page:number = 1;
	itemsPerPage:number = 5;
	maxSize:number = 5;
	numPages:number = 1;
	length:number = 0;

	config;
	configs:any = this.columnsRead.map(columns => ({
		paging: true,
		sorting: {columns: columns},
		filtering: {filterString: ''}
	}));

	/*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
		return data.slice(start, end);
	}

	changeSort(data:any, config:any):any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns || [];
		let columnName:string;
		let sort:string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous:any, current:any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}
			return 0;
		});
	}

	changeFilter(data:any, config:any):any {
		let filteredData:Array<any> = data;
		this.columnsRead[this.currentReadIndex].forEach((column:any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item:any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray:Array<any> = [];
		filteredData.forEach((item:any) => {
			let flag = false;
			this.columnsRead[this.currentReadIndex].forEach((column:any) => {
				if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});
			if (flag) {
				tempArray.push(item);
			}
		});
		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
		if (config.filtering) {
			Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
			Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);
		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

	//////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
